import React, { useState } from "react";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getCurrencieLabel } from "../../../../constants/currencies";
import { SelectTickets } from "../../../OpenSell/Steps";
import { ticketTypes } from "../../../../helpers/ticketHelper.ts";
import { applyDiscounts, getTotalPaymentAmount } from "../../../../helpers/ticketPriceHelper.ts";
import { executePayment } from "../../../../helpers/paymentHelper/paymentHelper.ts";
import { getCurrentLanguageTexts } from "../../../../constants/seasonPassPersonalInfoLangs.js";
import TermsAndConditionsModal from "../../TermsAndConditionsModal/TermsAndConditionsModal.js";
import { IconButton } from "../../../../components/UI/IconButton/IconButton.js";
import { filterUnavailableTicketTemplates } from "../../../../helpers/filterUnavailableTicketTemplates.js";

const MySwal = withReactContent(swal);

export const BuyTicketsOnFutureEventModal = ({ event, memberData, availiableSeatsCount, title, ...props }) => {
    const [state, setState] = useState({
        tickets: [],
        isLoading: false,
    });
    const [isTermsChecked, setTermsChecked] = useState(false);
    const [chart, setChart] = useState(null);

    const txt = getCurrentLanguageTexts();

    applyDiscounts(state.tickets, event.ticketTemplates);
    const { total, totalFee } = getTotalPaymentAmount(state.tickets, event);

    const confirmHandler = () => {
        setState(v => {
            return {
                ...v,
                isLoading: true,
            }
        });

        const redirectUrl = `${window.location.href}${window.location.href.includes('?') ? '&' : '?'}resultOrderId={Id}`;

        executePayment({
            eventData: event,
            paymentProvider: 0, // kopa only
            couponCode: '',
            redirectUrl: redirectUrl,
            tickets: state.tickets,
            paymentType: 1,
            transaction: {
                ...memberData,
            }
        })
    }

    const onTicketAdded = (ticket) => {
        setState(state => {

            if (ticket.type === ticketTypes.NO_SEAT) {
                const tickets = [...state.tickets, ticket];

                return {
                    ...state,
                    tickets
                };
            }

            if (state.chart && !ticket.masterTicket &&
                (state.tickets.some(t => t.label === ticket.label)
                ) && ticket.type === ticketTypes.MAP) {
                return {
                    ...state
                };
            }

            const tickets = [...state.tickets, ticket];

            return {
                ...state,
                tickets
            };
        })
    };

    const onTicketRemoved = (ticket, manual = false) => {

        if (chart && ticket.type === ticketTypes.MAP) {
            chart.deselectObjects([ticket.label]);
        }

        if (chart && ticket.type === ticketTypes.MAP_NO_SEAT && manual) {
            chart.deselectObjects([{ label: ticket.label, amount: 1 }]);
            return;
        }

        setState(state => {

            if (ticket.type === ticketTypes.NO_SEAT) {
                const index = state.tickets.findIndex(i => i.ticketTemplateId === ticket.ticketTemplateId);

                return (
                    {
                        ...state,
                        tickets: state.tickets.filter((item, i) => i !== index),
                    });
            }
            else if (ticket.type === ticketTypes.MAP_NO_SEAT) {
                const index = state.tickets.findIndex(i => i.label === ticket.label);
                return (
                    {
                        tickets: state.tickets.filter((item, i) => i !== index),
                    }
                );
            }
            else if (ticket.type === ticketTypes.MAP) {
                return (
                    {
                        tickets: state.tickets.filter((item) => item.id !== ticket.id),
                    }
                );
            }

        });
    };

    const handleTermsChangeCheckbox = (a) => {
        setTermsChecked(!isTermsChecked);
    }

    const showTermsAndConditionsModal = (ev) => {
        ev.preventDefault();
        MySwal.fire({
            html: <TermsAndConditionsModal />,
            width: "64em",
            customClass: "seasonpass__modal partizan-info-modal partizan-modal",
            showCloseButton: true,
        });
    };

    return <section className="buy-ticket-modal">

        <h2 className="first-title">{title}</h2>

        <div className="seasonpass-pers-info__buy-tickets-modal">
            <SelectTickets
                totalFee={totalFee}
                ticketTemplates={filterUnavailableTicketTemplates(event.ticketTemplates)}
                maxSelectedObjects={Math.min(availiableSeatsCount, event.maxSeatsToSelectPerTransaction)}
                pricing={event.ticketTemplates.map(({ ticketTemplateId, categoryKey, price }) => ({
                    category: categoryKey,
                    ticketTemplateId,
                    price,
                }))}
                tickets={state.tickets}
                onObjectSelected={onTicketAdded}
                onObjectDeselected={onTicketRemoved}
                hasSeats={event.ticketTemplates.length
                    ? event.ticketTemplates.filter(t => t.hasSeats) >= event.ticketTemplates.filter(t => !t.hasSeats)
                    : undefined}
                workspaceKey={event.seatsIoWorkspaceId}
                eventSeatsId={event.seatsIoEventId}
                event={event}
                currency={getCurrencieLabel(event.currencyId)}
                total={total}
                popupMode={true}
                isTermsChecked={isTermsChecked}
                handleChangeCheckbox={handleTermsChangeCheckbox}
                showTermsAndConditionsModal={showTermsAndConditionsModal}
                onSetChart={(c) => setChart(c)}
            />
        </div>

        <div className='swal2-actions'>

            <button className="swal2-cancel swal2-styled"
                onClick={() => MySwal.close()}>
                {txt.generalTxt.cancel}
            </button>

            <button disabled={!state.tickets.length || state.isLoading || !isTermsChecked} className="swal2-confirm swal2-styled"
                onClick={confirmHandler}>
                {txt.generalTxt.buy}
            </button>

        </div>

    </section>
}

